module.exports = __webpack_public_path__ + "img/bag2.fd8912a3.svg";